import React, { useState, useCallback } from 'react';
import { DashboardContextProvider } from '../context/DashboardContext';
import { DashboardContextData, DashboardDataGetters } from '../context/dashboardContext.types';

interface DashboardProviderProps<T = unknown> {
  children: React.ReactNode;
  dataGetters?: DashboardDataGetters<T>;
}

const DashboardProvider = <T = unknown,>({ children, dataGetters }: DashboardProviderProps<T>) => {
  const [expandedItems, setExpandedItems] = useState<Set<string | number>>(new Set());

  const toggleExpand = useCallback((id: string | number) => {
    setExpandedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  }, []);

  const contextValue: DashboardContextData = {
    expandedItems,
    toggleExpand,
    dataGetters: dataGetters as DashboardDataGetters<unknown>,
  };

  return <DashboardContextProvider value={contextValue}>{children}</DashboardContextProvider>;
};

export default DashboardProvider;
